import { useDataTablePagination } from '../../../../../../../ui/features/shift-details/hooks/useDataTablePagination';
import { useReviewParticipantsTableColumns, } from '../../../../../../../ui/features/shift-details/hooks/useReviewParticipantsTableColumns';
import { DataTable } from '@juvare/common-data-table-ui/DataTable';
import React from 'react';
export const ReviewParticipationsTable = ({ participations, onDenyParticipation, onParticipationClick, }) => {
    const pagination = useDataTablePagination({ data: participations });
    const { columns } = useReviewParticipantsTableColumns({ onDenyParticipation });
    return (React.createElement(DataTable, Object.assign({ onRowClick: onParticipationClick, filteredRowCount: participations.length, columns: columns, loading: false }, pagination)));
};
